import SortableTableTh from './SortableTableTh';

/** Compact sort headers for orders tables — click cycles asc → desc → clear. */
function OrdersSortableTh({ asLabel = false, ...props }) {
    return <SortableTableTh compact asLabel={asLabel} {...props} />;
}

export default OrdersSortableTh;
